<template>
    <div>
        <div class="inline _fill" v-for="(item, index) in data" :key="index">
            <div class="grid">
                <router-link  class="strong link" :to="'/users/' + item.id" >
                    <span v-if="item.firstname || item.lastname">{{ item.firstname + ' ' + item.lastname }}</span>
                    <span v-else>Парковщик {{ index + 1 }}</span>
                </router-link>
                <div class="form-item">
                    <label for="email">Email</label>
                    <input type="text" id="email" class="text-input" v-model="item.email" />
                </div>
                <div class="form-item">
                    <label for="password">Пароль</label>
                    <input type="text" id="password" class="text-input" v-model="item.password" />
                </div>
            </div>
            <div class="grid">
                <strong>Доступ к разделам:</strong>
                <div class="form-item checkbox">
                    <input type="checkbox" :id="'access_parking' + index" v-model="item.access_parking" />
                    <label :for="'access_parking' + index">Добавление/удаление мест</label>
                </div>
                <div class="form-item checkbox">
                    <input type="checkbox" :id="'access_discount' + index" v-model="item.access_discount" />
                    <label :for="'access_discount' + index">Изменение скидок</label>
                </div>
                <div class="form-item checkbox">
                    <input type="checkbox" :id="'access_booking' + index" v-model="item.access_booking" />
                    <label :for="'access_booking' + index">Просмотр текущего букинга</label>
                </div>
                <div class="form-item checkbox">
                    <input type="checkbox" :id="'access_settings' + index" v-model="item.access_settings" />
                    <label :for="'access_settings' + index">Основные настройки</label>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        props: ['data']
    }
</script>